import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
// import Home from '../pages/Home';
import Home from 'views/MainViews/Home';
import NftCreation from 'views/MainViews/NftCreation';
import Notification from 'views/MainViews/Notification';
import ProfilePage from 'views/MainViews/Profile';
import SignIn from 'views/MainViews/SignIn';
import SignUp from 'views/MainViews/SignUp';
// import Notification from '../pages/Notification';
// import NftCreation from '../pages/NftCreation';
import NftDetails from 'views/MainViews/NftDetails';
// import SignUp from '../pages/SignUp';
// import MobileProfile from '../pages/MobileProfile';
// import MainProfile from '../pages/MainProfile';
// import Explore from '../pages/Explore_bk';
// import ExploreNew from '../pages/Explore';
import { getUserData, updateUser } from 'APIs/AuthApi';
import { isValidToken, updateToken } from 'APIs/UserDataApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import CateogryModal from 'components/molecules/CategoryModal';
import OnBoardingPopup from 'components/organisms/OnBoardingPopup';
import { ACCESS_TOKEN } from 'constant';
import { login, selectAuth, setInvited } from 'features/auth/authSlice';
import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import ExploreNft from 'views/DesktopViews/Explore2Page/ExploreNft';
import ExploreOtr from 'views/DesktopViews/Explore2Page/ExploreOtr';
import Redirect from 'views/DesktopViews/Redirect';
import Terms from 'views/DesktopViews/TermsPage';
import About from 'views/MainViews/About';
import { Create } from 'views/MainViews/CreatePage/Create';
import CreateFund from 'views/MainViews/CreateFund';
import DMeesage from 'views/MainViews/DMessage';
import ExplorePage from 'views/MainViews/ExplorePage';
import FeaturedArtists from 'views/MainViews/FeaturedArtists';
import HotAuctions from 'views/MainViews/HotAuctions';
import Inbox from 'views/MainViews/Inbox';
import InviteCreator from 'views/MainViews/InviteCreator';
import OnBoarding from 'views/MainViews/OnBoarding';
import OtherProfilePage from 'views/MainViews/OtherProfile';
import OtrCreation from 'views/MainViews/OtrCreation';
import Policy from 'views/MainViews/Policy';
import RoadMap from 'views/MainViews/Roadmap';
import ProtectedRoute from './ProtectedRoute';
import Setting from 'views/MainViews/Setting';

const AppRouter = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const authState = useAppSelector(selectAuth);
  const navigate = useNavigate();
  // const [openSignInModal, setOpenSignInModal] = React.useState<boolean>(false);
  const [openOnBoardingModal, setOpenOnBoardingModal] =
    useState<boolean>(false);
  const [openCateogryModal, setOpenCategoryModal] = useState<boolean>(false);
  useEffect(() => {
    // setOpenSignInModal(!authState.authenticated);
    setOpenOnBoardingModal(
      authState.authenticated && !authState.seenOnBoarding
    );
    //eslint-disable-next-line
  }, [authState.authenticated]);
  useEffect(() => {
    //The function checks the URL for sign-in token and checks its validity,
    // if it is valid the function continues. Next the function checks for
    // any postId or creator token so that if creator token is there the user
    // will login and be made a creator whereas if a postId is found the user
    // will be redirected to the backstage and the relevant content's transaction
    // will be performed. In the end since we don't want to redirect to explore page everytime
    // we login and we are on different page and suddnely get redirected to explore, we will only
    // redirect to explore when we are logging in on homepage.
    async function checkLogin() {
      const urlLoginToken = location.search.split('signin=')[1];
      const creatorToken = location.search.split('token=')[1]?.split('&&')[0];
      let isExpired = { data: false };
      if (urlLoginToken) {
        isExpired = await isValidToken(urlLoginToken);
      }
      const postId = location.search.split('postId=')[1]?.split('&&')[0];
      // const creatorToken =
      //   !location.pathname.includes('Backstage') &&
      //   (!urlLoginToken || (urlLoginToken && location.search.includes('token')))
      //     ? location.search.split('token=')[1]
      //     : undefined;
      if (isExpired.data || postId || creatorToken) {
        await updateToken(urlLoginToken);
      }
      if (urlLoginToken) {
        localStorage.setItem(ACCESS_TOKEN, urlLoginToken);
      }
      if (!authState.authenticated) {
        const userData = await getUserData(creatorToken);
        if (userData) {
          userData.isCreator && creatorToken && dispatch(setInvited());
          dispatch(login({ ...userData }));
          if (!authState.seenOnBoarding)
            await updateUser({ id: userData.id, seenOnBoarding: true });
          if (postId) navigate(`home/backstage?postId=${postId}`);
          else if (
            (location.pathname === '/redirect' || location.pathname === '/') &&
            urlLoginToken
          )
            navigate('explore');
        }
      }
    }
    checkLogin();
    //eslint-disable-next-line
  }, [authState.authenticated, location.search]);

  return (
    <AnimatePresence>
      <OnBoardingPopup
        open={openOnBoardingModal}
        setOpen={setOpenOnBoardingModal}
        setOpenCategory={setOpenCategoryModal}
      />
      <CateogryModal
        openModal={openCateogryModal}
        setOpenModal={setOpenCategoryModal}
      />
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate replace to="/" />} />
        <Route path="/home/*" element={<Home />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/explore/nft/" element={<ExplorePage />} />
        <Route path="/explore/nft" element={<ExploreNft />} />
        <Route path="/explore/otr" element={<ExploreOtr />} />
        <Route path="/explore/nft/:id" element={<ExplorePage />} />
        <Route path="/explore/otr/:id" element={<ExploreOtr />} />
        <Route path="/explore2/:id" element={<ExplorePage />} />

        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />

        <Route
          path="/create/nft"
          element={<ProtectedRoute element={<NftCreation />} />}
        />

        <Route
          path="/create/otr"
          element={<ProtectedRoute element={<OtrCreation />} />}
        />

        <Route
          path="/create"
          element={<ProtectedRoute element={<Create />} />}
        />

        <Route path="/policy" element={<Policy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="/invite" element={<InviteCreator />} />
        <Route path="/profile/gallery" element={<ProfilePage />} />
        <Route path="/profile/:username" element={<OtherProfilePage />} />
        <Route path="/profile/:username/*" element={<OtherProfilePage />} />
        {/* <Route path="/nftauction/:id" element={<NftAuction />} /> */}
        <Route path="/nft-details/:id" element={<NftDetails />} />
        {/* <Route path="/explore" element={<Explore />} /> */}
        {/* <Route path="/test" element={<AnnouncementDialog />} /> */}
        <Route path="/createfund" element={<CreateFund />} />
        <Route path="/message" element={<Inbox />} />
        <Route path="/dm" element={<DMeesage />} />
        <Route path="/dm/:userId" element={<DMeesage />} />
        <Route path="/backstage/kyc" element={<About />} />
        <Route path="/onboarding" element={<OnBoarding />} />
        <Route path="/roadmap" element={<RoadMap />} />
        <Route path="/featured-artists" element={<FeaturedArtists />} />
        <Route path="/hot-auctions" element={<HotAuctions />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/setting" element={<Setting />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AppRouter;
